import React from 'react';
import {Link} from 'react-router-dom'
import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

const StyledComp = styled.div`
  width: calc(100% - 80px);
  padding: 48px 40px 0;
  max-width: 1400px;
  margin: 0 auto;


  @media (max-width: ${breakpoints.small}) {
    width: calc(100% - 48px);
    padding: 48px 24px 0;
  }

  .eyebrow {
    font-size: 13px;
    color: rgba(var(--blackr), 0.55);
    margin-bottom: 20px;
  }

  .headline {
    font-size: 56px;
    line-height: 1.08;
    letter-spacing: -0.02em;
    color: var(--black);
    margin: 0 0 32px;
  }

  .subrow {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 40px;

    @media (max-width: ${breakpoints.small}) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .description {
    font-size: 15px;
    line-height: 1.5;
    color: rgba(var(--blackr), 0.6);
    max-width: 560px;
    margin: 0;
  }

  .cta {
    flex-shrink: 0;
    background: var(--black);
    color: rgb(var(--whiter));
    border: none;
    border-radius: 6px;
    padding: 10px 20px;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    transition-duration: 0.3s;
    &:hover {
      background: rgba(var(--blackr), 0.85);

    }
  }

  .hero-image {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 6px;
    object-fit: cover;
  }
`;

const Comp = ({}) => {
  return (
    <StyledComp>
      <h2 className="headline serif">
        Less time wrangling data.
        <br />
        More time finding alpha.
      </h2>
      <div className="subrow">
        <p className="description">
          Alpha depends on speed and clarity. Axion gives hedge funds one
          financial data API for market data, fundamentals, alternative data, and
          quant tools. No more stitching together a dozen vendors. Just
          data you can act on.
        </p>
        <Link to='/contact' className="cta">Book demo</Link>
      </div>
      <img
        className="hero-image"
        src="/about/p3.jpg"
        alt="Conference room table"
      />
    </StyledComp>
  );
};

export default Comp;
